import React, { Component } from 'react'
import '../styles/Footer.css'
import Contact from './Contact'
import { injectIntl, defineMessages } from "react-intl"
import { Link } from 'react-router-dom'
import LearnMoreButton from './LearnMoreButton'
import PictoSmile from '../images/icons/pictosmile.png'

const TikTokIcon = () => (
  <svg className="footer-social-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M15.7 3c.35 2.35 1.72 3.75 4.3 3.9v3.08c-1.49.14-2.8-.34-4.22-1.22v5.77c0 7.34-8.02 9.63-11.25 4.37-2.08-3.39-.81-9.34 5.86-9.58v3.25c-.49.08-1.02.2-1.49.37-1.43.48-2.24 1.39-2.01 3 .43 3.08 6.09 3.99 5.62-2.02V3.01h3.19z" />
  </svg>
)

const InstagramIcon = () => (
  <svg className="footer-social-icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="5" y="5" width="14" height="14" rx="4" />
    <circle cx="12" cy="12" r="3.2" />
    <circle cx="16.45" cy="7.55" r="1" />
  </svg>
)

class Footer extends Component {
  render() {
    const {intl:{formatMessage}} = this.props
    const isEn = this.props.lang === 'en' || this.props.intl.locale === 'en'
    const bottomLinks = isEn ? [
      { to: '/escape-game-horreur/', label: 'Horror escape game Paris' },
      { to: '/cheque-vacances-escape-game-paris/', label: 'Chèques-Vacances' },
      { to: '/escape-game-deux-joueurs/', label: 'Escape game for 2 players' },
      { to: '/nos-tarifs/', label: formatMessage(messages.prices) },
      { to: '/enterrement-de-vie-de-garcon-escape-game/', label: 'Bachelor party escape game' },
      { to: '/enterrement-de-vie-de-jeune-fille-escape-game/', label: 'Bachelorette party escape game' },
      { to: '/escape-game-coupon-cadeau-entreprise/', label: 'Corporate bulk gift vouchers' },
      { to: '/location-decor-tournage/', label: 'Set rental for filming and photo shoots' }
    ] : [
      { to: '/escape-game-horreur/', label: 'Escape game horreur Paris' },
      { to: '/cheque-vacances-escape-game-paris/', label: 'Chèques Vacances' },
      { to: '/escape-game-deux-joueurs/', label: 'Escape game 2 joueurs' },
      { to: '/nos-tarifs/', label: formatMessage(messages.prices) },
      { to: '/enterrement-de-vie-de-garcon-escape-game/', label: 'EVG escape game' },
      { to: '/enterrement-de-vie-de-jeune-fille-escape-game/', label: 'EVJF escape game' },
      { to: '/escape-game-coupon-cadeau-entreprise/', label: 'Achat groupé comité entreprise' },
      { to: '/location-decor-tournage/', label: 'Location tournage et shooting' }
    ]

    return (
      <div className="footer">
        <div className="questions">
          <img src={PictoSmile} className="smile-icon" alt="smile-icon" />
          <h3>{formatMessage(messages.questions)}</h3>
          <h2>{formatMessage(messages.answers)}</h2>
          <div className="learn-more-faq">
            <Link to="/faq/">
              <LearnMoreButton text={formatMessage(messages.goToFAQ)} />
            </Link>
          </div>
        </div>
        <Contact />
		<div className="footer-bottom">
			<ul className="footer-navigationbottom">
            {bottomLinks.map((link) => <li key={link.to}><Link to={link.to}>{link.label}</Link></li>)}
          </ul>
		</div>
        <div className="footer-container">
          <div className="footer-social">
            <p>{formatMessage(messages.followUs)}</p>
            <div className="social-icons">
              <a target="_blank" rel="noopener noreferrer" aria-label="TikTok" title="TikTok"
                href="https://www.tiktok.com/@onehour_escapegame"
                className="icon-container">
                <TikTokIcon />
              </a>
              <a target="_blank" rel="noopener noreferrer" aria-label="Facebook" title="Facebook"
                href="https://www.facebook.com/onehourliveescapegame/"
                className="icon-container">
                <span className="footer-social-label footer-social-facebook">f</span>
              </a>
              <a target="_blank" rel="noopener noreferrer" aria-label="Instagram" title="Instagram"
                href="https://www.instagram.com/onehour_escape/"
                className="icon-container">
                <InstagramIcon />
              </a>
            </div>
          </div>
          <ul className="footer-navigation">
            <li><a rel="noopener noreferrer" href="https://escape-game-paris.one-hour.fr">{formatMessage(messages.blog)}</a></li>
            <li><Link to="/recrutement/">{formatMessage(messages.hiring)}</Link></li>
            <li><Link to="/presse/">{formatMessage(messages.press)}</Link></li>
            <li><Link to="/faq/">{formatMessage(messages.faq)}</Link></li>
            <li><Link to="/conditions-generales-de-vente/">{formatMessage(messages.businessTerms)}</Link></li>
            <li><Link to="/gamedesign-creation-de-live-escape-game/">Gamedesign</Link></li>
            <li><Link to="/plan-du-site/">{formatMessage(messages.siteMap)}</Link></li>
            <li><Link to="/mentions-legales/">{formatMessage(messages.generalConditions)}</Link></li>
          </ul>
        </div>
      </div>
    )
  }
}

const messages = defineMessages({
  questions: {
    id: 'landing.cta',
    defaultMessage: 'Vous avez un doute, une question ?'
  },
  answers: {
    id: 'landing.answers',
    defaultMessage: 'Nous avons la réponse !'
  },
  goToFAQ: {
    id: 'landing.goToFAQ',
    defaultMessage: 'Aller à la FAQ'
  },
  followUs: {
    id: 'footer.followUs',
    defaultMessage: 'Suivez-nous'
  },
  prices: {
    id: 'footer.prices',
    defaultMessage: 'Nos tarifs'
  },
  blog: {
    id: 'footer.blog',
    defaultMessage: 'Blog'
  },
  hiring: {
    id: 'footer.hiring',
    defaultMessage: 'Recrutement'
  },
    press: {
    id: 'footer.press',
    defaultMessage: 'Presse'
  },
    faq: {
    id: 'footer.faq',
    defaultMessage: 'FAQ'
  },
    businessTerms: {
    id: 'footer.businessTerms',
    defaultMessage: 'CGV'
  },
    siteMap: {
    id: 'footer.siteMap',
    defaultMessage: 'Plan du site'
  },
    generalConditions: {
    id: 'footer.generalConditions',
    defaultMessage: 'Mentions Légales'
  }
})

export default injectIntl(Footer)



// WEBPACK FOOTER //
// ./src/components/Footer.js